class AddOnPrice extends HTMLElement {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.sync = this.sync.bind(this);
  }

  connectedCallback() {
    this.scope = this.closest('product-info');
    this.scope?.addEventListener('change', this.handleChange);
    this.scope?.addEventListener('input', this.handleChange);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.sync);
    }
    this.sync();
  }

  disconnectedCallback() {
    this.scope?.removeEventListener('change', this.handleChange);
    this.scope?.removeEventListener('input', this.handleChange);
    this.quantityUpdateUnsubscriber?.();
  }

  handleChange(event) {
    if (event.target.matches('[data-add-on-option], .quantity__input')) this.sync();
  }

  getQuantity() {
    const quantity = parseInt(this.scope?.querySelector('.quantity__input')?.value, 10);
    return quantity > 0 ? quantity : 1;
  }

  sync() {
    const addOnInput = this.scope?.querySelector('[data-add-on-option]:checked');
    const addOnPrice = addOnInput && addOnInput.value !== 'none' ? Number(addOnInput.dataset.price || 0) : 0;

    const target = this.querySelector('.price-item--regular');
    if (!target) return;

    const cents = (Number(this.dataset.basePrice || 0) + addOnPrice) * this.getQuantity();
    const moneyFormat = this.dataset.moneyFormat || '{{amount}}';
    const formatted = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    target.textContent = moneyFormat.replace('{{amount}}', formatted);
  }
}

if (!customElements.get('add-on-price')) {
  customElements.define('add-on-price', AddOnPrice);
}
